import React from 'react';
import { Icon } from './Icon';

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: string;
  variant?: 'ghost' | 'surface' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  filled?: boolean;
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className = '', icon, variant = 'ghost', size = 'md', filled = false, ...props }, ref) => {
    const baseStyles =
      'inline-flex items-center justify-center rounded-lg transition-colors cursor-pointer disabled:opacity-50 disabled:pointer-events-none';

    const variants = {
      ghost: 'text-on-surface-variant hover:bg-primary-container',
      surface:
        'bg-surface-container-low hover:bg-surface-container-lowest hover:shadow-sm text-on-surface-variant hover:text-on-surface',
      outline:
        'border border-outline-variant/30 text-on-surface-variant hover:bg-primary/5 hover:text-primary rounded-full',
    };

    const sizes = {
      sm: 'p-1.5',
      md: 'p-2',
      lg: 'w-8 h-8',
    };

    const iconSizes = {
      sm: 'text-lg',
      md: '',
      lg: 'text-lg',
    };

    return (
      <button
        ref={ref}
        className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
        {...props}
      >
        <Icon name={icon} filled={filled} className={iconSizes[size]} />
      </button>
    );
  },
);
IconButton.displayName = 'IconButton';
